The type of position profile, i.e. `UnpostedPositionProfile`.
